var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8660",
    "data-name": "Group 8660",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M6.4,12.3a5.667,5.667,0,1,1,6.532,0l1.476,3.372a.354.354,0,0,1-.325.5H5.25a.354.354,0,0,1-.325-.5L6.4,12.3Zm4.771-.491.944-.667a4.25,4.25,0,1,0-4.9,0l.943.667L6.875,14.751h5.585l-1.287-2.943ZM6.918,8.354l1.374-.344a1.417,1.417,0,0,0,2.75,0l1.374.344a2.835,2.835,0,0,1-5.5,0Z",
    transform: "translate(-1.166 -0.584)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsIcon);
export default __webpack_public_path__ + "static/media/studentsIcon.08078cb6df35a4ba97b93a9ac7965c42.svg";
export { ForwardRef as ReactComponent };